function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n  z-index: 10;\n  position: relative;\n  .dropdown-input {\n    text-align: left;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  button {\n    padding: 0.8rem 1rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  button {\n    padding: 13px 10px;\n    width: 100px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  > * + * {\n    margin-left: 1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import styled from "styled-components";
import propTypes from "prop-types";
import { withContext } from "../../../wr-context";
import LayoutButton from "../../../layout-button";
import SearchBox from "../../../SearchBox";
import CategoriesDropdown from "./components/categories-dropdown";
import FiltersDropdown from "./components/filters-dropdown";
import SortingButton from "./components/sorting-button";
var ToolbarContainer = styled.div(_templateObject(), function(param) {
    var categoriesDropdown = param.categoriesDropdown;
    return categoriesDropdown && "\n    .dropdown-input {\n      margin-top: 1rem;\n    }\n  ";
});
var Filters = styled.div(_templateObject1());
var Sorting = styled.div(_templateObject2());
var ToolbarUtilities = styled.div(_templateObject3());
var ProductListToolbar = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ProductListToolbar, PureComponent);
    var _super = _createSuper(ProductListToolbar);
    function ProductListToolbar() {
        _classCallCheck(this, ProductListToolbar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.switchToList = function() {
            return _this.props.onChangeListMode("list");
        };
        _this.switchToGrid = function() {
            return _this.props.onChangeListMode("grid");
        };
        return _this;
    }
    var _proto = ProductListToolbar.prototype;
    _proto.render = function render() {
        var _props = this.props, listMode = _props.listMode, showLayoutButtons = _props.showLayoutButtons, showFilters = _props.showFilters, showSortingButton = _props.showSortingButton, toolbarType = _props.toolbarType, context = _props.context, filterByCategoryLabel = _props.filterByCategoryLabel, orderCategoriesAZ = _props.orderCategoriesAZ, orderCategoriesZA = _props.orderCategoriesZA, resetSelectedCategories = _props.resetSelectedCategories, customRenderer = _props.customRenderer;
        var categoriesDropdown = toolbarType === "categoriesDropdown";
        var filters = context.state.filters;
        var renderedParts = {
            textFilter: /*#__PURE__*/ React.createElement(SearchBox, {
                onChange: this.props.onChangeFilter,
                value: this.props.filter,
                categoriesDropdown: true,
                fullWidth: true,
                withReset: true,
                large: true
            }),
            layoutSwitch: showLayoutButtons && /*#__PURE__*/ React.createElement(LayoutButton, {
                listMode: listMode,
                switchToGrid: this.switchToGrid,
                switchToList: this.switchToList
            }),
            filtersDropdown: showFilters && filters.length > 0 && /*#__PURE__*/ React.createElement(Filters, null, /*#__PURE__*/ React.createElement(FiltersDropdown, null)),
            sortingButton: showSortingButton && /*#__PURE__*/ React.createElement(Sorting, null, /*#__PURE__*/ React.createElement(SortingButton, null)),
            categoriesDropdown: categoriesDropdown && /*#__PURE__*/ React.createElement(CategoriesDropdown, {
                filterByCategoryLabel: filterByCategoryLabel,
                orderCategoriesAZ: orderCategoriesAZ,
                orderCategoriesZA: orderCategoriesZA,
                resetSelectedCategories: resetSelectedCategories
            })
        };
        if (customRenderer) return customRenderer(renderedParts, this.props);
        return /*#__PURE__*/ React.createElement(ToolbarContainer, {
            categoriesDropdown: categoriesDropdown
        }, /*#__PURE__*/ React.createElement(ToolbarUtilities, null, renderedParts.textFilter, renderedParts.layoutSwitch, renderedParts.filtersDropdown, renderedParts.sortingButton), renderedParts.categoriesDropdown);
    };
    return ProductListToolbar;
}(PureComponent);
ProductListToolbar.propTypes = {
    onChangeFilter: propTypes.func.isRequired,
    onChangeListMode: propTypes.func.isRequired,
    filter: propTypes.any,
    toolbarType: propTypes.any,
    listMode: propTypes.oneOf([
        "list",
        "grid"
    ]),
    showLayoutButtons: propTypes.bool,
    filterByCategoryLabel: propTypes.string,
    orderCategoriesAZ: propTypes.bool,
    orderCategoriesZA: propTypes.bool,
    resetSelectedCategories: propTypes.bool
};
export default withContext(ProductListToolbar);
